import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://vciibxlacjoryxjtnnte.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZjaWlieGxhY2pvcnl4anRubnRlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTAyODAyODgsImV4cCI6MjA2NTg1NjI4OH0.M2flwU70yjkqmwwh2pNUkjA3KjTDEaUGfD-WbzAIXqg';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);